export const getBrandStateLabel = (brandState: string): string => {
  const stateLabels: Record<string, string> = {
    registered_has_no_campaigns: "Kayıt Olmuş Hiç Kampanya Açmamış",
    campaign_in_draft: "Kampanyası Taslakta Olan",
    campaign_created_balance_not_loaded: "Kampanya Açmış Bakiye Yüklememiş",
    loaded_balance_has_no_campaigns: "Bakiye Yüklemiş Kampanya Açmamış",
    campaign_created_has_no_applications: "Kampanya Açmış Henüz Başvuru Almamış",
    campaign_created_balance_loaded_has_no_applications:
      "Kampanya Açmış Bakiye Yüklemiş Henüz Başvuru Almamış",
    campaign_created_received_applications_profile_not_approved:
      "Kampanya Açmış Başvuru Almış Profil Onaylamamış",
    campaign_created_received_applications_profile_approved:
      "Kampanya Açmış Başvuru Almış Profil Onaylamış",
    campaign_created_received_applications_collaboration_completed:
      "Kampanya Açmış Başvuru Almış İş Birliği Tamamlamış",
    has_balance_loaded: "Bakiye Yüklemiş",
    has_balance_not_loaded: "Bakiye Yüklememiş",
    loaded_balance_multiple_times: "Birden Fazla Kez Bakiye Yüklemiş",
  }

  return stateLabels[brandState] || brandState
}
